<p class="u-text-align-center">{{ 'INSIGHTS.DASHBOARD.CLIENT_SOURCE.TITLE' | translate }}</p>
<span class="u-font-size-14 u-color-gray-dark u-text-align-center">{{ 'INSIGHTS.DASHBOARD.CLIENT_SOURCE.CONTENT' | translate }}</span>
